import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import './style.css';
var icons={
  height: "28px",
  width: "28px",
  color: "DimGray",
 
}
var foot={
  color:"DimGray",
  fontFamily: "Palatino, URW Palladio L, serif",
  letterSpacing: "12px",
  opacity: "0.5",
  fontSize: "13px",
  paddingBottom: "5px",

}
var style = {
    backgroundColor: "#222831",
    borderTop: "1px solid #E7E7E7",
    textAlign: "center",
    padding: "10px",
    position: "fixed",
    left: "0",
    bottom: "0",
    height: "80px",
    width: "100%",
    position:"fixed",
   marginTop: "auto",
}
const Footer= ()=>{
    return (
      <div>
        <footer className="footer" style={style}>
        <h1 className="text-center justify-content-center align-items-center" style={foot}>CONNECT WITH ME</h1>
          <ul className="list-unstyled list-inline text-center">
            <li className="list-inline-item">
              <a className="btn-floating btn-fb mx-3 col-xl-4 col-lg-4 col-md-12 col-sm-12 " href="https://github.com/sj056" >
              <GitHubIcon style={icons}/>
              </a>
            </li>
            <li className="list-inline-item">
              <a className="btn-floating btn-tw mx-3 col-xl-4 col-lg-4 col-md-12 col-sm-12" href="https://www.linkedin.com/in/shruti-sharma-1b1b131a6/">
              <LinkedInIcon style={icons}/>
              </a>
            </li>
            <li className="list-inline-item">
              <a className="btn-floating btn-gplus mx-3 col-xl-4 col-lg-4 col-md-12 col-sm-12" href="https://twitter.com/jangid006" >
              <TwitterIcon style={icons}/>
              </a>
            </li>
            
          </ul>
    
      </footer>
      </div>
    );
}
export default Footer